import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-auto"
}
const _hoisted_2 = { class: "p-inputgroup p-0 position-relative mt-auto pt-3" }
const _hoisted_3 = { class: "p-float-label hiding position-absolute" }
const _hoisted_4 = { class: "p-floating-label" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = { class: "container-top-end" }
const _hoisted_8 = {
  key: 0,
  class: "bi bi-gear"
}
const _hoisted_9 = {
  key: 1,
  class: "bi bi-cursor"
}
const _hoisted_10 = {
  key: 2,
  class: "mt-auto"
}
const _hoisted_11 = { class: "p-inputgroup p-0 position-relative mt-auto" }
const _hoisted_12 = { class: "p-float-label hiding position-absolute" }
const _hoisted_13 = { class: "p-floating-label" }
const _hoisted_14 = {
  key: 0,
  class: "position-absolute top-0 end-0",
  style: {"z-index":"10"}
}
const _hoisted_15 = {
  key: 0,
  class: "p-inputgroup"
}
const _hoisted_16 = { class: "p-float-label w-100 mt-3 d-flex" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cursor" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "p-inputgroup p-0 position-relative pt-3"
}
const _hoisted_20 = { class: "p-float-label hiding position-absolute" }
const _hoisted_21 = { class: "p-floating-label" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_CustomColorPicker = _resolveComponent("CustomColorPicker")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.property.format === 'enum')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t( 'editor.' + (_ctx.property.label ? _ctx.property.label : _ctx.id) )), 1)
          ]),
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.currValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currValue) = $event)),
            options: _ctx.property.values,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateConfig()))
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'enum.' + slotProps.option )), 1)
            ]),
            value: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'enum.' + slotProps.value )), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ])
      ]))
    : (_ctx.property.format === 'html')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeMode && _ctx.changeMode(...args)))
              }, [
                (_ctx.mode === _ctx.EditMode.Easy)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                  : (_openBlock(), _createElementBlock("i", _hoisted_9))
              ])
            ])
          ]),
          (_ctx.mode === _ctx.EditMode.Easy)
            ? (_openBlock(), _createBlock(_component_Editor, {
                key: 0,
                modelValue: _ctx.currValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currValue) = $event)),
                editorStyle: "height: 320px",
                onTextChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateConfig()))
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_Textarea, {
                key: 1,
                modelValue: _ctx.currValue,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currValue) = $event)),
                onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateConfig())),
                rows: "10",
                class: "w-100"
              }, null, 8, ["modelValue"]))
        ]))
      : (_ctx.property.format === 'color')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t( 'editor.' + (_ctx.property.label ? _ctx.property.label : _ctx.id) )), 1)
              ]),
              (_ctx.currValue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("i", {
                      class: "bi bi-x text-black bg-white d-flex rounded-circle cursor-pointer",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => {_ctx.currValue = null; _ctx.updateConfig();}, ["stop"]))
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_CustomColorPicker, {
                value: _ctx.currValue,
                onUpdate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateConfigVal($event)))
              }, null, 8, ["value"])
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (!_ctx.property.preDefined || _ctx.mode === _ctx.EditMode.Advanced)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_InputText, {
                      type: "text",
                      class: _normalizeClass(["flex-grow-1", _ctx.property.preDefined? 'p-inputgroup-not-last': '' ]),
                      modelValue: _ctx.currValue,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currValue) = $event)),
                      maxlength: _ctx.property.maxLength,
                      onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateConfig()))
                    }, null, 8, ["modelValue", "maxlength", "class"]),
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t( 'editor.' + (_ctx.property.label ? _ctx.property.label : _ctx.id) )), 1),
                    (_ctx.property.preDefined)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "p-inputgroup-addon flex-grow-0 border-start-0",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.changeMode && _ctx.changeMode(...args)))
                        }, _hoisted_18))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t( 'editor.' + (_ctx.property.label ? _ctx.property.label : _ctx.id) )), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.property.preDefined, (preDef) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: _normalizeClass(["p-inputgroup-addon flex-grow-1 cursor-pointer", preDef.value === _ctx.currValue ? 'bg-light':'']),
                      onClick: ($event: any) => (_ctx.updateConfigVal(preDef.value)),
                      key: preDef
                    }, [
                      _createVNode(_component_Icon, {
                        icon: preDef.icon
                      }, null, 8, ["icon"])
                    ], 10, _hoisted_22))
                  }), 128)),
                  (_ctx.property.preDefined)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "p-inputgroup-addon flex-grow-0",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.changeMode && _ctx.changeMode(...args)))
                      }, _hoisted_24))
                    : _createCommentVNode("", true)
                ]))
          ], 64))
}